import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import { initializeFirebase } from '@chartai/firebase';

import { App } from '@/app/App';
import { env } from '@/config/env';

import '@/styles/globals.css';

initializeFirebase(env.firebase);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
